// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
			.checking-payment-content {
				display: flex;
				flex-direction: column;
				align-items: center;
				justify-content: center;
				text-align: center;
				min-height: 200px;
				padding: 20px;
			}

			ion-spinner {
				width: 48px;
				height: 48px;
				margin-bottom: 20px;
			}

			h2 {
				margin: 0 0 8px;
				font-size: 20px;
				font-weight: 500;
			}

			p {
				margin: 0 0 20px;
				color: var(--ion-color-medium);
			}

			.progress-container {
				width: 100%;
				max-width: 300px;
				margin-top: 16px;
			}
		`, "",{"version":3,"sources":["webpack://./src/app/components/checking-payment-modal/checking-payment-modal.component.ts"],"names":[],"mappings":";GACG;IACC,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,iBAAiB;IACjB,aAAa;GACd;;GAEA;IACC,WAAW;IACX,YAAY;IACZ,mBAAmB;GACpB;;GAEA;IACC,eAAe;IACf,eAAe;IACf,gBAAgB;GACjB;;GAEA;IACC,gBAAgB;IAChB,8BAA8B;GAC/B;;GAEA;IACC,WAAW;IACX,gBAAgB;IAChB,gBAAgB;GACjB","sourcesContent":["\n\t\t\t.checking-payment-content {\n\t\t\t\tdisplay: flex;\n\t\t\t\tflex-direction: column;\n\t\t\t\talign-items: center;\n\t\t\t\tjustify-content: center;\n\t\t\t\ttext-align: center;\n\t\t\t\tmin-height: 200px;\n\t\t\t\tpadding: 20px;\n\t\t\t}\n\n\t\t\tion-spinner {\n\t\t\t\twidth: 48px;\n\t\t\t\theight: 48px;\n\t\t\t\tmargin-bottom: 20px;\n\t\t\t}\n\n\t\t\th2 {\n\t\t\t\tmargin: 0 0 8px;\n\t\t\t\tfont-size: 20px;\n\t\t\t\tfont-weight: 500;\n\t\t\t}\n\n\t\t\tp {\n\t\t\t\tmargin: 0 0 20px;\n\t\t\t\tcolor: var(--ion-color-medium);\n\t\t\t}\n\n\t\t\t.progress-container {\n\t\t\t\twidth: 100%;\n\t\t\t\tmax-width: 300px;\n\t\t\t\tmargin-top: 16px;\n\t\t\t}\n\t\t"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
